<template>
 <div class="wishlist">
		<div class="wishlist__share">
			<div class="wishlist__title">{{shareBundleTitle}}</div>

			<a
				:href="`https://www.facebook.com/sharer.php?u=${url}`"
				class="wishlist__link link link--withicon link--reverse"
				target="_blank">

				<span class="link__icon">
					<span class="icon icon-splotch-4 link__splotch">
						<svg><use href="#icon-splotch-4" /></svg>
					</span>

					<span class="icon icon-facebook link__symbol">
						<svg><use href="#icon-facebook" /></svg>
					</span>
				</span>
				<span class="link__text">Facebook</span>
			</a>

			<a
				:href="`https://twitter.com/share?url=${url}&text=${twitterText}`"
				class="wishlist__link link link--withicon link--reverse"
				target="_blank">

				<span class="link__icon">
					<span class="icon icon-splotch-2 link__splotch">
						<svg><use href="#icon-splotch-2" /></svg>
					</span>

					<span class="icon icon-twitter link__symbol">
						<svg><use href="#icon-twitter" /></svg>
					</span>
				</span>

				<span class="link__text">Twitter</span>
			</a>

			<button
				:href="`#`"
				class="wishlist__button link link--withicon link--reverse"
				@click.stop.prevent="copyUrl">

				<span class="link__icon">
					<span class="icon icon-splotch-2 link__splotch">
						<svg><use href="#icon-splotch-3" /></svg>
					</span>

					<span class="icon icon-link link__symbol">
						<svg><use href="#icon-link" /></svg>
					</span>
				</span>

				<span class="link__text">Copy Url</span>
			</button>

			<button
				data-fancybox
				data-src="#wishlist-form"
				class="wishlist__button link link--withicon link--reverse">

				<span class="link__icon">
					<span class="icon icon-splotch-2 link__splotch">
						<svg><use href="#icon-splotch-3" /></svg>
					</span>

					<span class="icon icon-link link__symbol">
						<svg><use href="#icon-link" /></svg>
					</span>
				</span>

				<span class="link__text">Email Wishlist</span>
			</button>

			<input type="hidden" id="wishlistUrl" :value="url" styles="display: none;" />
		</div>

		<div class="message" :class="{'is-visible':msgIsVisible}">
			<div class="message__text">{{msg}}</div>
		</div>
  </div>
</template>

<script>
export default {
	name: "ShareBundle",
	data() {
		let shareBundleTitle = this.title || "Share your wishlist on:"
		let shareBundleTwitterText = this.twitterText || "Wishlist"
		return {
			shareBundleTitle,
			shareBundleTwitterText,
			msg: "",
			msgIsVisible: false,
		}
	},
	props: [
		"url", // The url use to copy
		"copySuccessMessage", // Override copy successful message
		"copyFailMessage", // Override copy fail message
		"title",
		"twitterText",
	],
	methods: {
		copyUrl() {
			let urlToCopy = document.querySelector("#wishlistUrl")
			urlToCopy.setAttribute("type", "text")
			urlToCopy.select()

			try {
				let successful = document.execCommand("copy")
				// let msg = successful ? "successful" : "unsuccessful";
				let msgSuccess =
					this.copySuccessMessage ||
					"Link to your wishlist copied successfully."
				let msgError =
					this.copyFailMessage || "Error occurred. Please try again."

				if (successful) {
					this.msg = msgSuccess
				} else {
					this.msg = msgError
				}

				this.msgIsVisible = true
				setTimeout(() => {
					this.msgIsVisible = false
				}, 3000)
			} catch (err) {
				console.log("Oops, unable to copy")
			}

			/* unselect the range */
			urlToCopy.setAttribute("type", "hidden")
			window.getSelection().removeAllRanges()
		},

		// emailWishlist() {

		// }
	},
}
</script>

<style scoped>
</style>
